var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useTransitionState } from 'modules/hooks/useTransitionState';
import { StyledModal, Container } from './styled';
export function Drawer(props) {
    const { open, position = 'left', children, onClose, className } = props, restProps = __rest(props, ["open", "position", "children", "onClose", "className"]);
    const transitionState = useTransitionState(open, 200);
    if (transitionState === 'hidden') {
        return null;
    }
    return (<StyledModal onClose={onClose} autoFocus={false} {...restProps}>
      <Container $state={transitionState} $position={position} className={className}>
        {children}
      </Container>
    </StyledModal>);
}
